import request from '@/utils/request'

export function login(username, password, code) {
  return request({
    url: '/merchant/index/login',
    method: 'post',
    data: {
      username,
      password,
      code,
    },
  })
}

export function getInfo() {
  return request({
    url: '/merchant/user/get-info',
    method: 'post',
  })
}

export function logout() {
  return request({
    url: '/merchant/index/out',
    method: 'post',
  })
}

// 发送验证码
export function sendCode(data) {
  return request({
    url: '/merchant/index/send-code',
    method: 'post',
    data,
  })
}

// 获取图形验证码
export const captchaCode = process.env.VUE_APP_BASE_API + '/merchant/index/captcha?refresh'

// 重置密码
export const forgetPassword = (data) => {
  return request({
    url: '/merchant/index/reset-password',
    method: 'post',
    data,
  })
}

// 修改密码
export const updatePassword = (data) => {
  return request({
    url: '/merchant/user/update-password',
    method: 'post',
    data,
  })
}

// 自动登录
export const autoLogin = (data) => {
  return request({
    url: '/merchant/index/auto-login',
    method: 'post',
    data,
  })
}
